import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Logo from '../components/Logo';
import Navbar from '../Navbar';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';

import { ThemeClient } from '../contexts/Theme';
import { useAuth } from '../contexts/auth';
import { useHistory } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useCompany } from '../contexts/Company';

export default function Login() {
  const history = useHistory();
  const { signIn, fakeSignIn } = useAuth();
  const company = useCompany();
  const [emailReset, setEmailReset] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [username, setUsername] = useState('');

  const getProfile = async (email) => {
    const { data, error } = await supabase
      .from('users')
      .select('*')
      .eq('email', email)
      .single();

    if (error) {
      console.log(error.message);
      return null;
    }

    return data;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (company?.id == 45) {

      try {
        const { user, error } = await fakeSignIn({username, company: company.id});

        if (error) {
          setLoginError('Invalid user. If the problem persists, please contact Marcelo at marcelo@bauenconsulting.com.');
        } else {
          localStorage.setItem('username', username);
          console.log(user);
          if (user?.avatar) {
            history.push('/sessions');
          } else {
            history.push('/avatar');
          }
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
      const data = new FormData(event.currentTarget);
      let email = data.get('email');
      const password = data.get('password');

      try {
        if (email === 'admin') {
          email = 'admin@gmail.com';
        }

        const { user, error } = await signIn({
          email,
          password,
        });

        if (error) {
          setLoginError('Usuario o contraseña inválidos. Si el problema persiste, por favor contacta a Marcelo en marcelo@bauenconsulting.com.');
        } else {
          const profile = await getProfile(email);
          console.log(profile);
          if (profile?.avatar) {
            history.push('/sessions');
          } else {
            history.push('/avatar');
          }
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const handleForgotPassword = async (event) => {
    event.preventDefault();
    await supabase.auth.resetPasswordForEmail(emailReset, {
      redirectTo: 'https://bauenapp.vercel.app/update-password',
    });
    setOpenDialog(false);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  if (!company) return null;

  return (
    <ThemeClient>
      <Navbar title={company?.id == 45 ? 'Sign in' : 'Iniciar sesión'} />

      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Logo
            style={{
              height: 'auto',
              maxWidth: '100%',
              marginTop: '2rem',
              marginBottom: '2rem',
            }}
          />

          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            {loginError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {loginError}
              </Alert>
            )}

            {company?.id == 45 ? (
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="Mail"
                name="username"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            ) : (
              <>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Correo electrónico"
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Contraseña"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                />
              </>
            )}

            {company?.id !== 45 && (
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Recuérdame"
              />
            )}

            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              {company?.id === 45 ? "Sign in" : "Iniciar sesión"}
            </Button>
            {company?.id !== 45 && (
              <Grid container>
                <Grid item xs>
                  <Link variant="body2" onClick={handleOpenDialog}>
                    ¿Olvidaste tu contraseña?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="/register" variant="body2">
                    ¿No tienes una cuenta? Regístrate
                  </Link>
                </Grid>
              </Grid>
            )}
          </Box>
        </Box>
      </Container>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Recuperar contraseña</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Por favor, escribe tu correo electrónico para recuperar la contraseña, se te enviará un correo, <b>revisa spam</b>
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            id="recovery-email"
            label="Correo electrónico"
            type="email"
            fullWidth
            value={emailReset}
            onChange={(e) => setEmailReset(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancelar</Button>
          <Button onClick={handleForgotPassword}>Recuperar</Button>
        </DialogActions>
      </Dialog>
    </ThemeClient>
  );
}